import React from "react";
import { useUserTheme } from "src/shared/utils/useUserTheme";

interface CategorySectionProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

const CategorySection: React.FC<CategorySectionProps> = ({ searchQuery, onSearchChange }) => {
  const { fontClass, borderHighlight } = useUserTheme();
  return (
    <div className="flex items-center h-10 space-x-4" id="category-section">
      <h2 className="w-[135px] bg-[#F9F8FA] flex rounded-full items-center justify-center text-2xl">Category</h2>
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search the product"
        className={`w-full sm:w-auto px-3 py-2.5 border rounded-3xl focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`}
      />
    </div>
  );
};

export default CategorySection;
